/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * OpenAPI spec version: Latest
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Status for records of Assessment answers
 */
export type AssessmentAnswerStatus = 'Pending' | 'Successful' | 'Unsuccessful';

export const AssessmentAnswerStatus = {
    Pending: 'Pending' as AssessmentAnswerStatus,
    Successful: 'Successful' as AssessmentAnswerStatus,
    Unsuccessful: 'Unsuccessful' as AssessmentAnswerStatus
};